<template>
	<div>
		<Locations @locationsLoaded="onLocationsLoaded" />
	</div>
</template>

<script>
import Locations from './company-locations-view.vue';
import pageMixin from '@/mixins/page-mixin';

export default {
	name: 'DefaultSettings',
	mixins: [pageMixin],
	components: {
		Locations
	},
	methods: {
		onLocationsLoaded() {
			this.hidePageLoader();
		}
	}
};
</script>

<style lang="scss" scoped></style>
